<template>
  <v-navigation-drawer
    :model-value="modelValue"
    location="right"
    temporary
    width="280"
    color="#1e1e1e"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <div class="drawer-header">
      <span class="drawer-header__title">People ({{ participants.length }})</span>
      <v-btn icon size="small" variant="text" @click="$emit('update:modelValue', false)">
        <v-icon size="18">mdi-close</v-icon>
      </v-btn>
    </div>

    <v-divider color="#333" />

    <v-list density="compact" class="pa-0">
      <v-list-item
        v-for="p in participants"
        :key="p.identity"
        class="participant-item"
      >
        <template #prepend>
          <div class="participant-avatar">{{ initials(p.name) }}</div>
        </template>

        <v-list-item-title class="participant-name">
          {{ p.name }}
          <v-chip v-if="p.isAdmin" size="x-small" color="amber" label class="ml-1">Host</v-chip>
          <v-chip v-if="p.isLocal" size="x-small" color="grey" label class="ml-1">You</v-chip>
        </v-list-item-title>

        <v-list-item-subtitle v-if="p.audioMuted" class="text-error" style="font-size:0.7rem">
          <v-icon size="11">mdi-microphone-off</v-icon> Muted
        </v-list-item-subtitle>

        <!-- Admin controls for non-self, non-admin participants -->
        <template v-if="isAdmin && !p.isLocal" #append>
          <div class="participant-actions">
            <v-tooltip :text="p.audioMuted ? '' : 'Mute'" location="top">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  size="x-small"
                  variant="text"
                  :disabled="p.audioMuted"
                  :color="p.audioMuted ? 'error' : 'default'"
                  @click="$emit('mute', p.identity)"
                >
                  <v-icon size="16">{{ p.audioMuted ? 'mdi-microphone-off' : 'mdi-microphone' }}</v-icon>
                </v-btn>
              </template>
            </v-tooltip>

            <v-tooltip text="Remove" location="top">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  size="x-small"
                  variant="text"
                  color="error"
                  @click="$emit('kick', p.identity)"
                >
                  <v-icon size="16">mdi-account-remove</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </div>
        </template>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'ParticipantDrawer',

  props: {
    modelValue: { type: Boolean, default: false },
    // Array of { identity, name, audioMuted, mutedByAdmin, isAdmin, isLocal }
    participants: { type: Array, default: () => [] },
    isAdmin: { type: Boolean, default: false },
  },

  emits: ['update:modelValue', 'mute', 'kick'],

  methods: {
    initials(name) {
      return (name || '?')
        .split(' ')
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase() ?? '')
        .join('');
    },
  },
};
</script>

<style scoped>
.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
}

.drawer-header__title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #e0e0e0;
}

.participant-item {
  padding: 8px 12px;
  border-bottom: 1px solid #2a2a2a;
}

.participant-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #5c6bc0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
  color: #fff;
  margin-right: 8px;
  flex-shrink: 0;
}

.participant-name {
  font-size: 0.85rem;
  color: #e0e0e0;
  display: flex;
  align-items: center;
}

.participant-actions {
  display: flex;
  gap: 2px;
}
</style>
